"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.substitute = exports.addClassNameToElement = exports.useFormikIsChanged = exports.useFormikSubmissionSuccess = exports.useOutsideClick = exports.useToggleVisibility = exports.useInitialize = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _object = require("./object.js");

var _string = require("./string.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useSafeUpdate = function useSafeUpdate(updateState) {
  var isMounted = (0, _react.useRef)(true);
  var updateStateRef = (0, _react.useRef)();
  updateStateRef.current = updateState;
  var safeUpdateState = (0, _react.useCallback)(function (value) {
    if (isMounted.current) {
      updateStateRef.current(value);
    }
  }, []);
  (0, _react.useEffect)(function () {
    return function () {
      isMounted.current = false;
    };
  }, []);
  return safeUpdateState;
};

var useInitialize = function useInitialize(initialize) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isReady = _useState2[0],
      setIsReady = _useState2[1];

  var safeSetIsReady = useSafeUpdate(setIsReady);
  (0, _react.useEffect)(function () {
    var onCompletion = function onCompletion() {
      safeSetIsReady(true);
    };

    Promise.resolve(initialize()).then(onCompletion)["catch"](onCompletion);
    return function () {
      safeSetIsReady(false);
    };
  }, [initialize, safeSetIsReady].concat((0, _toConsumableArray2["default"])(dependencies))); // eslint-disable-line react-hooks/exhaustive-deps

  return isReady;
};

exports.useInitialize = useInitialize;

var useToggleVisibility = function useToggleVisibility() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialState = options.initialState,
      onOpen = options.onOpen,
      afterOpen = options.afterOpen,
      onClose = options.onClose,
      afterClose = options.afterClose,
      onChange = options.onChange;

  var _useState3 = (0, _react.useState)(initialState ? initialState : false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isComponentVisible = _useState4[0],
      __setComponentVisible = _useState4[1];

  var _setComponentVisible = (0, _react.useCallback)(function (newVisibility) {
    if (typeof onOpen === "function" && !isComponentVisible && newVisibility) {
      onOpen();
    }

    if (typeof onClose === "function" && isComponentVisible && !newVisibility) {
      onClose();
    }

    if (typeof onChange === "function" && isComponentVisible !== newVisibility) {
      onChange({
        isOpen: newVisibility
      });
    }

    __setComponentVisible(newVisibility);

    if (typeof afterOpen === "function" && !isComponentVisible && newVisibility) {
      setTimeout(afterOpen, 0);
    }

    if (typeof afterClose === "function" && !isComponentVisible && newVisibility) {
      setTimeout(afterClose, 0);
    }
  }, [isComponentVisible, onOpen, afterOpen, onClose, afterClose, onChange]);

  var setComponentVisible = useSafeUpdate(_setComponentVisible);
  var toggleComponentVisible = (0, _react.useCallback)(function () {
    setComponentVisible(!isComponentVisible);
  }, [isComponentVisible, setComponentVisible]);
  return {
    isComponentVisible: isComponentVisible,
    setComponentVisible: setComponentVisible,
    toggleComponentVisible: toggleComponentVisible
  };
};

exports.useToggleVisibility = useToggleVisibility;

var useOutsideClick = function useOutsideClick(onClick, givenRef) {
  var defaultRef = (0, _react.useRef)(null);
  var ref = givenRef || defaultRef;
  (0, _react.useEffect)(function () {
    var handleClick = function handleClick(event) {
      if (typeof onClick === "function" && ref.current && !ref.current.contains(event.target)) {
        onClick();
      }
    };

    document.addEventListener("click", handleClick, true);
    return function () {
      document.removeEventListener("click", handleClick, true);
    };
  }, [ref, onClick]);
  return ref;
};

exports.useOutsideClick = useOutsideClick;

var useFormikSubmissionDone = function useFormikSubmissionDone() {
  var _useFormikContext = (0, _formik.useFormikContext)(),
      isSubmitting = _useFormikContext.isSubmitting,
      isValidating = _useFormikContext.isValidating,
      values = _useFormikContext.values;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      submissionPending = _useState6[0],
      setSubmissionPending = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      submissionDone = _useState8[0],
      setSubmissionDone = _useState8[1];

  (0, _react.useEffect)(function () {
    if (isSubmitting) {
      setSubmissionPending(true);
    }
  }, [isSubmitting]);
  (0, _react.useEffect)(function () {
    if (submissionPending) {
      setSubmissionDone(false);
    }
  }, [submissionPending]);
  (0, _react.useEffect)(function () {
    if (submissionPending && !isSubmitting && !isValidating) {
      setSubmissionPending(false);
      setSubmissionDone(true);
    }
  }, [submissionPending, isSubmitting, isValidating]);
  (0, _react.useEffect)(function () {
    setSubmissionDone(false);
  }, [values]);
  return submissionDone;
};

var useFormikSubmissionSuccess = function useFormikSubmissionSuccess() {
  var _useFormikContext2 = (0, _formik.useFormikContext)(),
      isValid = _useFormikContext2.isValid;

  var submissionDone = useFormikSubmissionDone();

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      submissionSuccess = _useState10[0],
      setSubmissionSuccess = _useState10[1];

  (0, _react.useEffect)(function () {
    setSubmissionSuccess(submissionDone && isValid);
  }, [submissionDone, isValid]);
  return submissionSuccess;
};

exports.useFormikSubmissionSuccess = useFormikSubmissionSuccess;

var useFormikIsChanged = function useFormikIsChanged() {
  var _useFormikContext3 = (0, _formik.useFormikContext)(),
      values = _useFormikContext3.values;

  var submissionDone = useFormikSubmissionDone();

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      isChanged = _useState12[0],
      setIsChanged = _useState12[1];

  var isInitialRun = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (submissionDone) {
      setIsChanged(false);
    }
  }, [submissionDone]);
  (0, _react.useEffect)(function () {
    if (isInitialRun.current) {
      isInitialRun.current = false;
    } else {
      setIsChanged(true);
    }
  }, [values]);
  return isChanged;
};

exports.useFormikIsChanged = useFormikIsChanged;

var addClassNameToElement = function addClassNameToElement(element, className) {
  return /*#__PURE__*/_react["default"].cloneElement(element, {
    className: (0, _classnames["default"])(element.props.className, className)
  });
};

exports.addClassNameToElement = addClassNameToElement;

var substitute = function substitute() {
  var template = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lastId = 0;
  var children = template // Replace linked text ('[...]') with substitution markers
  .replace(/\[(.*?)\]/g, function (_, part) {
    var onLinkedTextClick = options.onLinkedTextClick,
        href = options.href;

    if (onLinkedTextClick) {
      var identifier = "__linkIdentifier_".concat(++lastId);
      data = (0, _object.merge)(data, (0, _defineProperty2["default"])({}, identifier, /*#__PURE__*/_react["default"].createElement("span", {
        className: "__linked-text",
        onClick: onLinkedTextClick
      }, part)));
      return "{".concat(identifier, "}");
    } else if (href) {
      var _identifier = "__linkIdentifier_".concat(++lastId);

      data = (0, _object.merge)(data, (0, _defineProperty2["default"])({}, _identifier, /*#__PURE__*/_react["default"].createElement("a", {
        className: "__linked-text",
        href: href
      }, part)));
      return "{".concat(_identifier, "}");
    } else {
      return part;
    }
  }) // Replace substitution markers ('{...}')
  .split(/(\{.*?\})/).map(function (part, index) {
    var partWithoutBrackets = part.slice(1, -1);
    var className = "substituted-".concat((0, _string.toKebabCase)(partWithoutBrackets));
    var substitution = /^\{(.*)\}$/.test(part) ? /*#__PURE__*/_react["default"].createElement("span", {
      className: className
    }, data[partWithoutBrackets]) || "" : part;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, substitution);
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

exports.substitute = substitute;